import axios from "axios";
import TagManager from "react-gtm-module";

export const ANALYTICS_CONSENT_KEY = "jobbli_analytics_consent";
export const ANALYTICS_SESSION_KEY = "jobbli_analytics_session";

let initialized = false;

export const getAnalyticsConsent = () =>
  localStorage.getItem(ANALYTICS_CONSENT_KEY);

export const setAnalyticsConsent = (value) => {
  localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
};

export const getAnalyticsSessionId = () => {
  let sessionId = sessionStorage.getItem(ANALYTICS_SESSION_KEY);
  if (!sessionId) {
    sessionId = `${Date.now().toString(36)}-${Math.random()
      .toString(36)
      .slice(2, 12)}`;
    sessionStorage.setItem(ANALYTICS_SESSION_KEY, sessionId);
  }
  return sessionId;
};

export const initializeAnalytics = ({
  gtmId = process.env.REACT_APP_GOOGLE_TAG_MANAGER,
  clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID,
} = {}) => {
  if (initialized || getAnalyticsConsent() !== "granted") {
    return false;
  }

  if (gtmId) {
    TagManager.initialize({ gtmId });
  }

  if (clarityProjectId && typeof window !== "undefined") {
    window.clarity =
      window.clarity ||
      function clarity() {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    if (!document.querySelector(`script[data-clarity-id="${clarityProjectId}"]`)) {
      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${clarityProjectId}`;
      script.setAttribute("data-clarity-id", clarityProjectId);
      document.head.appendChild(script);
    }
  }

  initialized = true;
  return true;
};

export const resetAnalyticsInitializationForTests = () => {
  initialized = false;
};

export const trackPortalEvent = async (eventType, eventData = {}) => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/analytics/event`,
      {
        event_type: eventType,
        event_data: {
          ...eventData,
          sessionId: getAnalyticsSessionId(),
          path: window.location.pathname,
        },
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return true;
  } catch (_) {
    return false;
  }
};
